import clone from "clone";
export const serverVersionHeaderName = "X-Server-Version";
export function currentUrl() {
    return parseUrl(window.location);
}
export function parseUrl(url) {
    let path = "";
    let query = {};
    let hiddenQuery = {};
    let host = null;
    let port = null;
    let scheme = null;
    if (typeof url === "string") {
        const parts = url.split("?");
        path = parts[0];
        if (path.indexOf("//") === 0 || path.indexOf("http") === 0) {
            const parseUrlRegex = new RegExp("^((?:https?|file):)?//" + // protocol
                "(([^:/?#]*)(?::([0-9]+))?)" + // host (hostname and port)
                "(/{0,1}[^?#]*)" // pathname
            );
            const match = path.match(parseUrlRegex);
            scheme = match[1];
            host = match[3];
            if (match[4]) {
                port = +match[4];
            }
            path = match[5];
        }
        if (!path) {
            path = "/";
        }
        query = searchToObject(parts[1]);
    }
    else if (isLocation(url)) {
        path = url.pathname;
        query = searchToObject(url.search.split("?").pop());
        host = url.hostname;
        port = url.port ? +url.port : null;
        scheme = url.protocol;
    }
    else if (isUrlObject(url)) {
        // Url is already parsed but might not contain `query` and `hiddenQuery`
        path = url.path;
        query = clone(url.query || {});
        hiddenQuery = clone(url.hiddenQuery || {});
        host = url.host;
        port = url.port;
        scheme = url.scheme;
    }
    return {
        path,
        query,
        hiddenQuery,
        host,
        port,
        scheme,
    };
}
// We cannot use `url instanceof Location` because location objects in IE
// are not instances of that constructor
function isLocation(url) {
    return !!url && "hash" in url && "pathname" in url && "origin" in url;
}
export function isExternal(url) {
    if (!url.host) {
        return false;
    }
    const current = currentUrl();
    if (url.host.replace(/^www./, "") === current.host.replace(/^www./, "")) {
        return false;
    }
    return true;
}
export function urlToString(url, includeHiddenQuery = false) {
    if (!url) {
        return null;
    }
    else if (typeof url === "string") {
        return urlToString(parseUrl(url));
    }
    else {
        let q = queryToString(url.query);
        if (includeHiddenQuery && url.hiddenQuery) {
            const hiddenQ = queryToString(url.hiddenQuery);
            q = (q === "" ? hiddenQ : q + "&" + hiddenQ).replace(/&$/, "");
        }
        const pathAndQuery = url.path + (q === "" ? "" : "?" + q);
        const port = url.port ? ":" + url.port : "";
        return (url.host ? url.scheme + "//" + url.host + port : "") + pathAndQuery;
    }
}
export function areEqual(url1, url2, compareHiddenQuery = false) {
    let urlObject1 = null;
    let urlObject2 = null;
    if (typeof url1 === "string") {
        urlObject1 = parseUrl(url1);
    }
    else {
        urlObject1 = url1;
    }
    if (typeof url2 === "string") {
        urlObject2 = parseUrl(url2);
    }
    else {
        urlObject2 = url2;
    }
    if (urlObject1.path !== urlObject2.path) {
        return false;
    }
    if (queryToString(urlObject1.query) !== queryToString(urlObject2.query)) {
        return false;
    }
    if (compareHiddenQuery &&
        queryToString(urlObject1.hiddenQuery) !==
            queryToString(urlObject2.hiddenQuery)) {
        return false;
    }
    return true;
}
const validUrlKeys = ["path", "query", "hiddenQuery", "host", "scheme", "port"];
export function isUrlObject(url) {
    if (!url || typeof url !== "object") {
        return false;
    }
    if ("path" in url && typeof url.path === "string") {
        const otherKeys = Object.keys(url).filter((key) => validUrlKeys.indexOf(key) === -1);
        if (otherKeys.length === 0) {
            let validKeyTypes = true;
            if (url.query && typeof url.query !== "object") {
                validKeyTypes = false;
            }
            if (url.hiddenQuery && typeof url.hiddenQuery !== "object") {
                validKeyTypes = false;
            }
            return validKeyTypes;
        }
        else {
            return false;
        }
    }
    return false;
}
export function pathCombine(first, ...rest) {
    let result = first;
    for (let i = 0; i < rest.length; i++) {
        if (result[result.length - 1] !== "/") {
            result += "/";
        }
        const current = rest[i][0] === "/" ? rest[i].substr(1) : rest[i];
        if (current) {
            result += current;
        }
    }
    return result;
}
function queryToString(query) {
    if (!query) {
        return "";
    }
    let queryString = "";
    const keys = Object.keys(query).sort();
    keys.forEach((k) => {
        if (Array.isArray(query[k])) {
            const queryParams = query[k].slice();
            queryParams.sort();
            queryParams.forEach((v) => {
                queryString += createQueryKeyValuePair(k, v);
            });
        }
        else {
            queryString += createQueryKeyValuePair(k, query[k]);
        }
    });
    return queryString.replace(/&$/, "");
}
function createQueryKeyValuePair(key, value) {
    if (value === null || value === undefined) {
        return encodeURIComponent(key) + "&";
    }
    else {
        return encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
}
function searchToObject(search) {
    // decodeURIComponent doesn't convert + to a space so we need to handle it manually.
    // A key with no "=" (e.g. from a null/undefined value serialized by
    // createQueryKeyValuePair) has value === undefined here and must stay null,
    // not become the literal string "undefined".
    const decode = (value) => value === undefined
        ? null
        : decodeURIComponent(String(value).replace(/\+/g, "%20"));
    const query = {};
    if (search) {
        search.split("&").forEach((q) => {
            const [key, value] = q.split("=");
            if (key in query) {
                if (!Array.isArray(query[key])) {
                    query[key] = [query[key]];
                }
                query[key].push(decode(value));
            }
            else {
                query[key] = decode(value);
            }
        });
    }
    return query;
}
